export const cutTitle = ({ title, maxLength }) => {
  if (!title) {
    return '';
  }

  if (title.length > maxLength) {
    return title.slice(0, maxLength) + "...";
  }

  return title;
};
